import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Actions as FACILITYACTIONS } from '../../store/actions/facilityActions';
import { Actions as USAGEACTIONS } from '../../store/actions/usageActions';
import { Trash2, CloudUpload } from 'lucide-react';
import { Button } from '../ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
} from '../ui/dialog';
import FacilitiesImportModal from './FacilitiesImportModal';

let remove = false;
export const handleFileRemove = () => {
  remove = true;
};

const UploadFacilityData = ({
  getUploadLink,
  showFacilityImportModal,
  facilityImportModal,
  processFacilitiesUpload,
  processingFacilityImport,
  facilityAnalysisImportModal,
  importKey,
}) => {
  const [file, setFile] = useState(null);
  const [inputDisabled, setInputDisabled] = useState(false);
  const isInputDisabled = file || inputDisabled;

  if (remove) {
    setFile(null);
    remove = false;
  }

  const selectFile = async (e) => {
    const newFile = e.target.files && e.target.files[0];
    setFile(newFile);
    getUploadLink(newFile);
    e.target.value = '';
  };

  if (!facilityImportModal) return null;

  const closeModal = () => {
    showFacilityImportModal(false);
    setFile(null);
    importKey = undefined;
  };

  const handleFileRemove = () => {
    setInputDisabled(true);
    setFile(null);
    importKey = undefined;
    setTimeout(() => {
      setInputDisabled(false);
    }, 10);
  };

  return (
    <>
      <Dialog
        open={!!facilityImportModal}
        onOpenChange={(open) => {
          if (!open) closeModal();
        }}>
        <DialogContent
          onClose={closeModal}
          className='max-h-[90vh] overflow-y-auto sm:max-w-lg font-body text-sm'>
          <DialogHeader>
            <DialogTitle className='font-body'>Import Facilities</DialogTitle>
          </DialogHeader>
          <DialogBody className='space-y-4'>
            <div className='flex flex-wrap items-center gap-2'>
              <span className='font-semibold text-foreground'>Download template:</span>
              <a
                id='import-link-excel'
                href='https://s3.eu-west-2.amazonaws.com/downloads.compareyourfootprint.com/facilities_template.xlsx'
                className='text-primary hover:underline cursor-pointer'>
                Excel
              </a>
            </div>
            <div id='file-name' className='text-foreground'>
              <span className='font-semibold'>File name: </span>
              <span>{file?.name ?? '—'}</span>
            </div>
            <div className='flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center'>
              <div className='flex shrink-0 items-center'>
                {file ? (
                  <Button variant='outline' onClick={handleFileRemove}>
                    <Trash2 size={16} strokeWidth={1.5} />
                    <span>Remove File</span>
                  </Button>
                ) : (
                  <Button variant='outline' asChild>
                    <label
                      htmlFor='import_input'
                      id='Facility-Modal-uploadButton'
                      className='cursor-pointer inline-flex items-center gap-2 mb-0'>
                      <CloudUpload size={16} strokeWidth={1.5} />
                      <span>Upload File</span>
                    </label>
                  </Button>
                )}
                <input
                  id='import_input'
                  disabled={isInputDisabled}
                  type='file'
                  accept='.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
                  onChange={selectFile}
                  className='sr-only'
                />
              </div>
              <Button
                disabled={!file || importKey === undefined}
                onClick={() => processFacilitiesUpload(file)}
                id='Facility-Modal-startImportButton'
                loading={processingFacilityImport}>
                Start Import
              </Button>
            </div>
          </DialogBody>
        </DialogContent>
      </Dialog>
      {facilityAnalysisImportModal && <FacilitiesImportModal />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    facilityImportModal: state.facility?.facilityImportModal,
    processingFacilityImport: state.facility?.processingFacilityImport,
    facilityAnalysisImportModal: state.facility.facilityAnalysisImportModal,
    importKey: state.importUploadKey,
  };
};

const mapDispatchToProps = (dispatch) => ({
  processFacilitiesUpload: (file) => dispatch(FACILITYACTIONS.processFacilitiesUpload(file)),
  getUploadLink: (file) => dispatch(USAGEACTIONS.getUploadLink(file)),
  showFacilityImportModal: (status) => dispatch(FACILITYACTIONS.showFacilityImportModal(status)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UploadFacilityData);
